import instance from '../utils/instance';

class PlanTaskService {
    async getTaskList(projectId){
        return await instance.get('/pms/task/getPmsTask?t='+new Date().getTime()+'&projectId='+projectId);
    }

    async getMileStoneList() {
        return await instance.get('/pms/milestone/getMilestones?t='+new Date().getTime());
    }

    async savePlanTasks(projectId, tasks){
        return await instance.post('/pms/task/savePmsTask?t='+new Date().getTime(),
            {
                projectId: projectId,
                json: JSON.stringify(tasks)
            });
    }

    async getTaskStatusInfo(projectId){
        return await instance.get('/pms/task/getTaskStatus?t='+new Date().getTime()+'&projectId='+projectId);
    }

    async updateTaskStatusInfo(taskId, week, status){
        return await instance.post('/pms/task/updateTaskStatus?t='+new Date().getTime(),
            {
                taskId: taskId,
                week: week,
                status: status
            });
    }

    async getAvailableTemplate(){
        return await instance.get('/pms/task/getTemplates?t='+new Date().getTime());
    }

    async importTemplate(templateId){
        return await instance.get('/pms/task/importTemplate?t='+new Date().getTime()+'&templateId='+templateId);
    }

    async saveAsTemplate(name, remark, tasks){
        return await instance.post('/pms/task/saveAsTemplate?t='+new Date().getTime(),
            {
                name: name,
                remark: remark,
                json: JSON.stringify(tasks)
            });
    }

    async updatePlanDate(weeks,projectId,startTime,endTime){
        return await instance.post('/pms/task/updatePlanDate?t='+new Date().getTime(),
            {
                weeks: weeks.join(","),
                projectId: projectId,
                startTime: startTime,
                endTime: endTime
            });
    }

    async getReportInfo(week,projectId){
        return await instance.post('/pms/task/getReportInfo?t='+new Date().getTime(),
            {
                week: week,
                projectId: projectId
            });
    }
}

export default new PlanTaskService();